"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plan = void 0;
exports.Plan = {
    create: (_features, _limits, definition) => {
        return {
            ID: definition.id,
            NAME: definition.name,
            VISIBLE: definition.visible,
            PRICING: definition.pricing,
            can: (test) => {
                const planFeature = definition.features[test.featureKey];
                if (planFeature === undefined) {
                    throw new Error(`Invalid feature ${test.featureKey} on plan`);
                }
                const isAllowed = planFeature[test.actionKey];
                if (isAllowed === undefined) {
                    throw new Error(`Invalid action ${test.actionKey} for ${test.featureKey} on plan`);
                }
                return isAllowed;
            },
            getLimit: (limitKey) => {
                return definition.limits[limitKey];
            },
        };
    },
};
